<template>
    <svg class="commentIcon" viewBox="0 0 24 24">
        <path
            :fill="primaryColor"
            d="M20,2A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M4,4V17.17L5.17,16H20V4H4M6,7H18V9H6V7M6,11H15V13H6V11Z" />
    </svg>
</template>

<script>

export default {
  name: 'CommentIcon',
  props: {
      primaryColor: String,
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.commentIcon {
    height: 24px;
    width: 24px;

    margin-right: 12px;
    margin-left: 12px;
}

</style>